import { BusinessGatedFeatureModal } from '@ltvco/refresh-lib/v2';

import imgBulkPropertyGatedModal from 'images/img_bulk_property_gated_modal.png';
import imgContactEnrichmentGatedModal from 'images/img_contact_enrichment_gated_modal.png';

import type { ComponentProps } from 'react';

export type BusinessGatedFeatureKey =
  | 'bulk-property-search'
  | 'contact-enrichment';

export type BusinessGatedFeatureModalContent = Pick<
  ComponentProps<typeof BusinessGatedFeatureModal>,
  'title' | 'description' | 'disclaimer' | 'featureHighlights' | 'illustration'
>;

export const BUSINESS_GATED_ROUTE_BY_PATH: Record<
  string,
  BusinessGatedFeatureKey
> = {
  '/dashboard/import-list': 'bulk-property-search',
  '/dashboard/contact-enrichment': 'contact-enrichment',
};

export const BUSINESS_GATED_FEATURE_MODAL_CONTENT: Record<
  BusinessGatedFeatureKey,
  BusinessGatedFeatureModalContent
> = {
  'bulk-property-search': {
    title: 'Unlock Bulk Property Search',
    description:
      'Upload a list of addresses to quickly research property and ownership details.',
    disclaimer: 'Your data is secure with BeenVerified',
    featureHighlights: [
      'Upload hundreds of addresses at once',
      'Find ownership, property, and valuation details',
      'Export results for review and analysis',
    ],
    illustration: (
      <img
        src={imgBulkPropertyGatedModal}
        alt=""
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
    ),
  },
  'contact-enrichment': {
    title: 'Unlock Contact Enrichment',
    description:
      'Upload a contact list to search for missing names, addresses, phone numbers, and emails.',
    disclaimer: 'Your uploaded files remain private and will not be shared',
    featureHighlights: [
      'Upload your contact list in seconds',
      'Find missing names, addresses, phone numbers, and emails',
      'Export enriched contacts for outreach',
    ],
    illustration: (
      <img
        src={imgContactEnrichmentGatedModal}
        alt=""
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
    ),
  },
};
